// EP-73 — AI Feature Coach (ผู้ช่วยแนะนำฟีเจอร์)
export default {
  bubble: {
    pill: 'เคล็ดลับ',
    heading: 'ทำได้เลย',
    why_label: 'ทำไมจึงสำคัญ',
    steps_label: 'ขั้นตอน',
    time_estimate: '~{{minutes}} นาที',
    resume_cta: 'ทำต่อ',
    discover_cta: 'ดูวิธีทำ',
    assets_label: 'ไฟล์พร้อมใช้',
    download_asset: 'ดาวน์โหลด',
    dismiss: 'ปิด',
    snooze: 'ไว้ทีหลัง',
    done: 'เสร็จแล้ว',
  },
  static: {
    title: 'ตั้งค่า{{feature}}',
    why: 'ทำขั้นตอนนี้ให้เสร็จเพื่อใช้งาน FlowRent ได้เต็มประสิทธิภาพ',
    step: 'เปิด{{feature}}แล้วทำตามขั้นตอนบนหน้าจอ',
  },
  features: {
    property_created: 'อสังหาริมทรัพย์แรกของคุณ',
    unit_created: 'ห้อง/ยูนิต',
    customer_created: 'ลูกค้า',
    lease_created: 'สัญญาเช่า',
    esign_link_sent: 'ลิงก์เซ็นสัญญา',
    lease_signed: 'การเซ็นสัญญา',
    meter_added: 'มิเตอร์',
    meter_reading_recorded: 'การจดมิเตอร์',
    caf_configured: 'ค่าส่วนกลาง',
    invoice_created: 'ใบแจ้งหนี้',
    invoice_sent: 'การส่งใบแจ้งหนี้',
    payment_recorded: 'การชำระเงิน',
    report_viewed: 'รายงาน',
    report_exported: 'การส่งออกรายงาน',
    maintenance_created: 'คำขอแจ้งซ่อม',
    maintenance_resolved: 'การปิดงานซ่อม',
    equipment_created: 'อุปกรณ์',
    work_order_created: 'ใบสั่งงาน',
    vehicle_added: 'รถสำหรับที่จอด',
    parcel_scanned: 'การสแกนพัสดุ',
    parcel_assigned: 'การจ่ายพัสดุ',
    timesheet_logged: 'การลงเวลาทำงาน',
    expense_created: 'ค่าใช้จ่าย',
    bank_statement_uploaded: 'การกระทบยอดธนาคาร',
    gl_account_setup: 'ผังบัญชี',
    late_fee_policy_set: 'นโยบายค่าปรับล่าช้า',
    etax_issued: 'ใบกำกับภาษีอิเล็กทรอนิกส์',
    liff_published: 'มินิแอป LINE ของคุณ',
    rich_menu_set: 'ริชเมนู LINE',
    microsite_published: 'ไมโครไซต์อสังหาฯ ของคุณ',
    announcement_published: 'ประกาศ',
    line_oa_configured: 'บัญชี LINE Official ของคุณ',
    template_customized: 'เทมเพลตเอกสารของคุณ',
  },
} as const
